import React, { useState, useEffect, useCallback } from "react";
import { TemplatePageOverview } from './styles';
import { Carousel, Icon, Tooltip, Checkbox } from 'antd';
import PageNotFoundIllustration from '../../images/generatingPreview.png';
import { correctBaseUrl } from '../../utils/svgUtils';
import URL from '../../utils/helper';
import { useTranslation } from "react-i18next";
import { ADD_EMAIL_ATTACHMENT_MODAL } from "./translationValues";

const THUMBNAIL_KEY = 'thumbnail';
const generateThumbnailUrl = (documentId) => `${URL.DESIGN_SYSTEM_URL}dynamic/thumbnail/${documentId}`;
const generateEmailThumbnailUrl = (documentId) => `${URL.DESIGN_SYSTEM_URL}email/thumbnail/${documentId}`;

const NAMESPACES = ['ADD_EMAIL_ATTACHMENT_MODAL'];

const TemplateMenuItem = ({
  templateObj,
  inverted,
  onMenuClick,
  onPreviewClick,
  renderDropDown,
  isMailTemplates,
  previewText,
  noCarousel = false,
  isComplex = false,
  isEmailTemplate = false,
  ...props
}) => {
  const [firstPageImageLink, setFirstPageImageLink] = useState(templateObj[THUMBNAIL_KEY] || templateObj?.thumbNailUrl || undefined);
  const [loading, setLoading] = useState(true);

  const { t } = useTranslation(NAMESPACES);

  useEffect(() => {
    if (isComplex && !templateObj[THUMBNAIL_KEY]) {
      setLoading(true);
      const thumbnail = isEmailTemplate ? generateEmailThumbnailUrl(templateObj.id) : generateThumbnailUrl(templateObj.id); 
      setFirstPageImageLink(thumbnail);
    }
  }, [templateObj, isComplex]);

  const onImageError = useCallback(() => {
    setFirstPageImageLink(undefined);
    setLoading(false);
  }, []);

  const onLoad = useCallback(() => {
    setLoading(false);
  }, []);

  return (
    <TemplatePageOverview
      key={templateObj.id}
      onClick={onMenuClick}
      title={templateObj.name}
      inverted={inverted ? 1 : 0}
      isMailTemplates={isMailTemplates ? 1 : 0}
      attachmentTemp={props.attachmentTemp}
    >
      <div className="template-media">
        <div className="image-wrapper">
          {props.attachmentTemp && templateObj.isEditable && (
            <div className="editable-icon-tag">
              <Tooltip title={t(ADD_EMAIL_ATTACHMENT_MODAL.EDITABLE_TEMPLATE_TOOLTIP.key, ADD_EMAIL_ATTACHMENT_MODAL.EDITABLE_TEMPLATE_TOOLTIP.value)}>
                <Icon type="edit" style={{ fontSize: 14, color: '#ffffff' }} />
              </Tooltip>
            </div>
          )}
          {!isMailTemplates && !noCarousel ?
            <Carousel autoplay dots={false}>
              {templateObj.flows &&
                templateObj.flows.length > 0 &&
                templateObj.flows.map(pageObj => {
                  let thumbnail = correctBaseUrl(pageObj.thumbnail);
                  return (
                    <div key={pageObj.pageId}>
                      <img
                        src={PageNotFoundIllustration}
                        alt="pageObj-thumbnail"
                        className={!thumbnail ? 'no-thumbnail' : ''}
                      />
                    </div>
                  );
                })}
            </Carousel>
            : <div style={{ height: '100%' }}>
              {templateObj &&
                <div key={templateObj.id} style={{ height: '100%' }} className={loading ? 'show-loader' : ''}>
                  <img
                    src={firstPageImageLink ? firstPageImageLink : PageNotFoundIllustration}
                    alt="pageObj-thumbnail"
                    className={!loading && !firstPageImageLink ? 'no-thumbnail no-margin' : ''}
                    onError={onImageError}
                    onLoad={onLoad}
                  />
                </div>
              }
            </div>
          }
        </div>
        <Tooltip title={previewText || "Preview"} placement="top">
          <div
            className="preview-button"
            onClick={onPreviewClick}
          >
            <Icon type="eye" />
          </div>
        </Tooltip>
        {renderDropDown && renderDropDown()}
      </div>
      <div className='template-name'>
        <h2>
          {props.showCheckbox && (
            <Tooltip title="Protected" placement="top">
              <Checkbox
                checked={props.checkboxValue}
                onChange={props.onCheck}
              />
            </Tooltip>
          )}
          {templateObj.documentName || templateObj.name}
        </h2>
        {props.languageList && !props.isMasterTab && templateObj?.language && (
          <Tooltip title={props.languageList?.find(ln => ln.code === templateObj?.language)?.name} trigger="hover">
            <div className={'language-tag'}>{templateObj?.language}</div>
          </Tooltip>
        )}
      </div>
     
    </TemplatePageOverview >
  );
}

export default TemplateMenuItem;